import { useEffect, useState } from "react";
import type { ElementType } from "react";
import { adminApi } from "../../api/admin";
import { isAdmin } from "../../util/SecurityUtils";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

interface GenericInputProps {
  id: string;
  inputType?: string;
  placeholderText?: string;
  as?: ElementType;
}

export const GenericInput = ({ id, inputType = "text", placeholderText = ":)", as = "input" }: GenericInputProps) => {
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    adminApi.getGenericInput(id)
      .then(data => {
        setValue(data || "");
      })
  }, [id]);

  const handleSave = () => {
    setSaving(true)
    setEditing(false)
    adminApi.createOrUpdateGenericInput({ id, content: value })
      .finally(() => setSaving(false))
  };

  if (isAdmin()) {
    if (!editing) {
      return <div onClick={() => setEditing(true)} className="clickable" style={{whiteSpace: "pre-wrap"}}>
        {value || placeholderText}
      </div>
    } else {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: "8px" }}>
          <Form.Control type={inputType} as={as}
                        onChange={e => setValue(e.target.value)}
                        value={value} />
          { editing && <Button variant="outline-light" onClick={handleSave} disabled={saving}>✔</Button> }
        </div>
      );
    }
  }

  return <div style={{whiteSpace: "pre-wrap"}}>{value}</div>;
};
